"use client";

import { Inter } from "next/font/google";
import "./globals.css";
import Header from "@/components/header/Header";
import Footer from "@/components/footer/footer";
import DataContext from "@/ContextApi";

import { usePathname } from "next/navigation";
import { BlogProvider } from "@/ContextApi/blogContext";
import WhatsAppButton from "@/components/Whatsapp-icon/whatsapp";
import FloatingBannerHome from "@/components/home/FloatingBanner/page";
import Breadcrumb from "@/components/Breadcrumb";

const inter = Inter({ subsets: ["latin"] });
 
// const metadata = {
//   title: "Study Abroad",
// };

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const path = usePathname();
  const isAdminRoute = path.startsWith("/adminsetup/admin");

  return (
    <html lang="en">
      <head>
        <meta name="facebook-domain-verification" property="og:facebook-domain-verification" content="a32xfq3zucmicza9yg2ut8r5jbm0o7" />
      </head>
      <meta
        property="og:title"
        content="Global HealthCare Education With Study Abroad by Academically"
      />
      <meta
        property="og:description"
        content="Study Abroad by Academically: Expert counseling, AI recommendations, visa support, and global partnerships for healthcare education. Start your journey today."
      />
      <meta
        property="og:image"
        content="https://f2.leadsquaredcdn.com/t/academically/content/common/images/Screenshot%202025-02-19%20181148.png"
      />
      <meta property="og:url" content="https://studyabroad.academically.com/" />
      <meta property="og:type" content="website" />

      {isAdminRoute && (
          <meta name="robots" content="noindex, nofollow" />
        )}

      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=GT-TBVGQG9Q"
      />
      <script
        dangerouslySetInnerHTML={{
          __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'GT-TBVGQG9Q');
            `,
        }}
      />

      {/* Google Tag Manager */}
      {/* <script
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-KWPJMHLB');`,
        }}
      />
      <script
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-KVB6TPT5');`,
        }}
      />


      <script

        dangerouslySetInnerHTML={{
          __html: `
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','GTM-NGVPNLRV');
        `,
        }}
      /> */}


      <body className={inter.className}>
        {/* <noscript>
          <iframe
            src="https://www.googletagmanager.com/ns.html?id=GTM-KWPJMHLB"
            height="0"
            width="0"
            style={{ display: "none", visibility: "hidden" }}
          ></iframe>
        </noscript>
        <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KVB6TPT5"
          height="0" width="0" style={{ "display": "none", "visibility": "hidden" }}></iframe></noscript>

        <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NGVPNLRV"
          height="0" width="0" style={{ "display": "none", "visibility": "hidden" }}></iframe></noscript> */}

        <DataContext>
          <BlogProvider>
            {!isAdminRoute && <Header />}
            {!isAdminRoute &&  <Breadcrumb />}
            {children}
            {!isAdminRoute && <WhatsAppButton />}
            {!isAdminRoute && <FloatingBannerHome />}
            {!isAdminRoute && <Footer />}
          </BlogProvider>
        </DataContext>
      </body>
    </html >
  );
}
